import { render, staticRenderFns } from "./ProductsInOrderModal.vue?vue&type=template&id=0fa73a46&scoped=true"
import script from "./ProductsInOrderModal.vue?vue&type=script&lang=js"
export * from "./ProductsInOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa73a46",
  null
  
)

export default component.exports